import { render, staticRenderFns } from "./ACheckboxYN.vue?vue&type=template&id=4bc8787c&"
import script from "./ACheckboxYN.vue?vue&type=script&lang=js&"
export * from "./ACheckboxYN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports